import qs from 'qs';
import apiClient from './apiClient';
import { history } from 'modules/navigator';

export class User {
  public async init() {
    const { token } = qs.parse(window.location.search.replace('?', ''));

    if (typeof token === 'string' && localStorage.getItem('oauth')) {
      this.setToken(token);
    }

    if (this.token) {
      return;
    }
  }

  public get token() {
    return localStorage.getItem('token');
  }

  public get authorized() {
    return !!this.token;
  }

  public logout() {
    localStorage.removeItem('token');
  }

  public async login() {
    await apiClient.base.oauth({ mp: 'jsysdy' });
  }

  public setToken(token: string) {
    localStorage.setItem('token', token);
    localStorage.removeItem('oauth');
  }


  /**
   * 必须授权手机号
   *
   */
  public requireMobile = async () => {
    const { body } = await apiClient.base.userinfo({});
    const phone = body? body.mobile : null
    if (!this.token) {
      this.login()
      return false;
    }
    if(!phone || phone == '') {
      alert('需要先授权手机号！')
      history.push('/bindPhone')
      return false;
    }
    return true
  }
}

export const user = new User();

const store = {
  user
};

export default store;
